/* eslint-env browser */
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const dismissTimeout = 5000;
let timeoutId = null;
const AUToastComponent = ({ message: pMessage, dismiss, onOpen }) => {
  const { type, message } = pMessage;
  const toastRef = useRef(null);
  const persistent = type !== 'confirm';

  const moveOut = (element) => {
    const moveOutClass = 'toast-notification--move-out';
    element.classList.add(moveOutClass);
    const moveOutElement = document.querySelector(`.${moveOutClass}`);
    if (moveOutElement) {
      moveOutElement.addEventListener('animationend', () => {
        dismiss();
      });
    }
  };

  useEffect(() => {
    onOpen();
  }, []);

  useLayoutEffect(() => {
    const element = toastRef.current;
    if (!persistent) {
      if (element) {
        element.addEventListener('animationend', () => {
          timeoutId = setTimeout(() => {
            moveOut(element);
          }, dismissTimeout);
        });
        element.addEventListener('mouseenter', () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
            element.addEventListener('mouseleave', () => {
              moveOut(element);
            });
          }
        });
      }
    } else {
      element.querySelector('button').focus();
    }
  }, []);

  let className = `theme--normal toast-notification toast-notification--${type}`;
  if (persistent) {
    className = `${className} toast-notification--persistent`;
  }
  return (
    <div ref={toastRef} className={className}>
      <div className="toast-notification__content">
        <p dangerouslySetInnerHTML={{ __html: message }} />
      </div>
      {
        persistent && (
          <button
            type="button"
            className="button"
            onClick={() => {
              moveOut(toastRef.current);
            }}
          >
            OK
          </button>
        )
      }
    </div>
  );
};

AUToastComponent.defaultProps = {
  dismiss: () => {},
  onOpen: () => {},
};

AUToastComponent.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  dismiss: PropTypes.func,
  onOpen: PropTypes.func,
};

AUToastComponent.displayName = 'AUToastComponent';
export default AUToastComponent;
